module.exports = __webpack_public_path__ + "img/nawin.e40f505b.jpg";